import React from 'react'
import { createUseStyles } from 'react-jss'
import { formatPrice } from '../../helpers/format'
import theme from '../../style/theme'
import { vw } from '../../style/vw'

// Free shipping threshold in USD
const FREE_SHIPPING_THRESHOLD = 500.00

const FreeShippingProgress = ({ totalAmount }) => {
  const classes = useStyles()

  // Calculate how much more is needed for free shipping
  const amountNeeded = Math.max(0, FREE_SHIPPING_THRESHOLD - totalAmount)

  // Calculate the progress percentage (0-100)
  const progressPercentage = Math.min(100, (totalAmount / FREE_SHIPPING_THRESHOLD) * 100)

  // Determine if free shipping is achieved
  const freeShippingAchieved = totalAmount >= FREE_SHIPPING_THRESHOLD

  return (
    <div className={classes.freeShippingContainer}>
      <div className={classes.messageContainer}>
        {freeShippingAchieved ? (
          <p className={classes.message}>
            You've qualified for <span className={classes.highlight}>FREE SHIPPING!</span>
          </p>
        ) : (
          <p className={classes.message}>
            You are <span className={classes.highlight}>{formatPrice(amountNeeded)}</span> away from <span className={classes.highlight}>FREE SHIPPING!</span>
          </p>
        )}
      </div>

      <div className={classes.progressBarContainer}>
        <div
          className={classes.progressBarFill}
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  freeShippingContainer: {
    marginBottom: vw(15),
    width: '100%',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      marginBottom: vw(15, 'desktop')
    }
  },
  messageContainer: {
    marginBottom: vw(8),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginBottom: vw(8, 'desktop')
    }
  },
  message: {
    margin: 0,
    fontSize: vw(12),
    fontFamily: theme.fonts.body,
    color: theme.colors.primary,
    [theme.breakpoints.up('md')]: {
      fontSize: vw(12, 'desktop')
    }
  },
  highlight: {
    fontWeight: 'bold',
    color: theme.colors.primary
  },
  progressBarContainer: {
    height: vw(8),
    backgroundColor: '#E0E0E0',
    borderRadius: 10,
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      height: vw(8, 'desktop')
    }
  },
  progressBarFill: {
    height: '100%',
    backgroundColor: theme.colors.primary,
    borderRadius: 10,
    transition: 'width 0.5s ease-in-out'
  }
}, { name: 'FreeShippingProgress' })

export default FreeShippingProgress
